import { PropsWithChildren } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

type TextInputProps = PropsWithChildren<
  React.InputHTMLAttributes<HTMLInputElement>
>;

export const TextInput = (props: TextInputProps): JSX.Element => {
  const { onChange, ...rest } = props;
  return (
    <input
      type="text"
      onChange={onChange}
      className={classNames(props.className, styles.input)}
      {...rest}
    />
  );
};
